import React from 'react';
import ImageUploading from 'react-images-uploading';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEdit,faTrash} from '@fortawesome/free-solid-svg-icons';
const ALLOWED_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const ImagesUploader = ({multiple,name,title,data,handleImages}) => {
    return (
        <div className='images-uploader'>
            <ImageUploading
                value={data}
                name={name}
                multiple={multiple}
                onChange={im => handleImages(name,im)}
                maxNumber={69}
                dataURLKey="data_url"
                acceptType={ALLOWED_TYPES}
                maxFileSize={MAX_FILE_SIZE}
                onError={(errors) => {
                    if (errors?.acceptType) alert('Invalid file type. Allowed formats: JPG, JPEG, PNG, GIF, WEBP.');
                    if (errors?.maxFileSize) alert('File is too large. Maximum size per image is 5 MB.');
                }}
            >
                {({
                      imageList,
                      onImageUpload,
                      onImageRemoveAll,
                      onImageUpdate,
                      onImageRemove,
                      isDragging,
                      dragProps,
                  }) => (
                    <div className="upload__image-wrapper">
                        <h6 className='title-label'>{title}</h6>
                        <div className="d-flex">
                            <button className='button-green me-2'
                                    style={isDragging ? { color: 'red' } : undefined}
                                    onClick={onImageUpload}
                                    {...dragProps}
                            >
                                Upload
                            </button>
                            <button className='button-yellow' onClick={onImageRemoveAll}>Remove images</button>
                        </div>
                        <div className="images-wrapper">
                            {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                    <img src={image['data_url'] || image['url']} alt="" width="100" />
                                    <div className="image-item__btn-wrapper mt-2 d-flex">
                                        <button className='edit-small-button me-2' onClick={() => onImageUpdate(index)}>
                                            <FontAwesomeIcon icon={faEdit}/>
                                        </button>
                                        <button className='delete-small-button' onClick={() => onImageRemove(index)}>
                                            <FontAwesomeIcon icon={faTrash}/>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </ImageUploading>
        </div>
    );
};

export default ImagesUploader;